import React from 'react';
import { UpdateInfoWrapper } from '../../../pages/tank-cleaning/TankCleaning.styles';
import { ChemicalRobPortCall } from '../../../types/ViewModel/TankCleaning/ROB/ChemicalRobPortCall';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { prettifyDateTimeHHmm } from 'odfjell-date-time-utils/dateTimeFormatter';

type Props = {
    chemicalRobForPortCall: ChemicalRobPortCall | null;
};
const PrintRobUpdateInfoComponent: React.FC<Props> = (props) => {
    return (
        <UpdateInfoWrapper className="print">
            {props.chemicalRobForPortCall && props.chemicalRobForPortCall?.lastUpdatedUtc && props.chemicalRobForPortCall?.lastUpdatedBy && (
                <>
                    <h4>Updated</h4>
                    <span>
                        <FontAwesomeIcon
                            className="profile-icon"
                            icon="user"
                            title={'Last update by ' + props.chemicalRobForPortCall?.lastUpdatedBy}
                        />
                        <span>{props.chemicalRobForPortCall?.lastUpdatedBy}</span>
                    </span>
                    <span>
                        <FontAwesomeIcon
                            className="clock-icon"
                            icon="clock"
                            title={'Last update ' + prettifyDateTimeHHmm(props.chemicalRobForPortCall?.lastUpdatedUtc)}
                        />
                        <span>{prettifyDateTimeHHmm(props.chemicalRobForPortCall?.lastUpdatedUtc)}</span>
                    </span>
                </>
            )}
        </UpdateInfoWrapper>
    );
};

export default PrintRobUpdateInfoComponent;
